module.exports = __webpack_public_path__ + "img/9-1.7c2fb596.jpg";